export default "__VITE_ASSET__BESNV8PH__"